/**
 * @file
 * The delayed loading spinner.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el, setHidden } = berTags.dom;

  // Loading hint with the blue spinner. An optional show delay keeps fast
  // responses from flashing it.
  components.spinner = () => {
    const loading = el('div', 'ber-tags__loading is-hidden');
    loading.textContent = Drupal.t('Loading…');
    let timer = null;
    return {
      el: loading,
      show: (delay = 0) => {
        clearTimeout(timer);
        if (delay) {
          timer = setTimeout(() => setHidden(loading, false), delay);
        } else {
          setHidden(loading, false);
        }
      },
      hide: () => {
        clearTimeout(timer);
        setHidden(loading, true);
      },
    };
  };
})(Drupal);
